import React from 'react';
import PropTypes from 'prop-types';
import "../style.css";

/**
 * Panel for displaying and managing favorite videos
 * 
 * @param {Array} favorites - Array of favorite video objects
 * @param {function} loadFavorite - Function to load a favorite video
 * @param {function} removeFromFavorites - Function to remove a favorite
 */
const FavoritesPanel = ({
  favorites,
  loadFavorite,
  removeFromFavorites
}) => {
  return (
    <section className="favorites-panel">
      <div>
        <h3 className='favorites-title'>Favorites</h3>
      </div>
      
      {favorites.length > 0 ? (
        <div className="favorites-list">
          {favorites.map(favorite => (
            <div key={favorite.id} className="favorite-item">
              <div 
                className="favorite-title" 
                onClick={() => loadFavorite(favorite)}
                title={favorite.title}
              >
                {favorite.title}
              </div>
              <button 
                onClick={() => removeFromFavorites(favorite.id)} 
                className="remove-button"
                title="Remove from favorites"
              >
                ✕
              </button>
            </div>
          ))}
        </div>
      ) : (
        <div className="no-favorites">
          No favorites saved yet. Save videos by pasting a YouTube URL and clicking the star icon.
        </div>
      )}
    </section>
  );
};

FavoritesPanel.propTypes = {
  favorites: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired
  })).isRequired,
  loadFavorite: PropTypes.func.isRequired,
  removeFromFavorites: PropTypes.func.isRequired
};

export default FavoritesPanel;